import Dexie, { type Table } from 'dexie';
import type {
  Item,
  PantryKnowledge,
  ShoppingItem,
  Subscription,
  UserSettings,
} from './schema.js';
import { DEFAULT_USER_SETTINGS } from './schema.js';
import type { InventoryEvent } from '../events/types.js';

class HamsterDB extends Dexie {
  events!: Table<InventoryEvent, string>;
  items!: Table<Item, string>;
  pantryKnowledge!: Table<PantryKnowledge, string>;
  shoppingItems!: Table<ShoppingItem, string>;
  subscriptions!: Table<Subscription, string>;
  settings!: Table<UserSettings, string>;

  constructor() {
    super('HamsterDB');
    this.version(1).stores({
      // events table: id (ULID, sortable), indexed by type and timestamp for filtering
      events: 'id, type, timestamp',
      // projected entities (cache rebuildable from events)
      items: 'id, normalizedName, category, location, status',
      pantryKnowledge: 'id, name, category',
      shoppingItems: 'id, status, source, addedAt, subscriptionId',
      subscriptions: 'id, knowledgeId, active, nextDelivery',
      settings: 'id',
    });
  }
}

export const db = new HamsterDB();

export async function getOrCreateSettings(): Promise<UserSettings> {
  const existing = await db.settings.get('singleton');
  if (existing) return existing;
  await db.settings.put(DEFAULT_USER_SETTINGS);
  return DEFAULT_USER_SETTINGS;
}
